<template>
  <v-container fluid class="mt-3 pr-8">
    <p class="text-h6 font-weight-light text-uppercase">{{ $t('users') }}<v-spacer></v-spacer>
     <v-tooltip right>
       <template v-slot:activator="{ on, attrs }">
        <v-badge
        bordered
        color="error"
        overlap
        dot
        :value="filtered"
        >
          <v-icon 
            v-bind="attrs"
            v-on="on" 
            @click="showSearch = !showSearch">
              search
          </v-icon>
        </v-badge>
      </template>
      <span>{{ searchLabel }}</span>
      </v-tooltip>
    </p>

    <!--    Row for filters    -->
    <v-row v-show="showSearch">
      <!--   SearchName  -->
      <v-col xs="12" sm="6" md="3" lg="3">
        <v-text-field
          :clearable="true"
          dense
          v-bind:label="$t('name')"
          outlined
          prepend-inner-icon="search"
          v-model="filter.name"
        >
        </v-text-field>
      </v-col>

      <!--   SearchLastname  -->
      <v-col xs="12" sm="6" md="3" lg="3">
        <v-text-field
          :clearable="true"
          dense
          v-bind:label="$t('lastname')"
          outlined
          prepend-inner-icon="search"
          v-model="filter.lastname"
        >
        </v-text-field>
      </v-col>

      <!--   SearchUsername  -->
      <v-col xs="12" sm="6" md="3" lg="3">
        <v-text-field
          :clearable="true"
          dense
          v-bind:label="$t('username')"
          outlined
          prepend-inner-icon="search"
          v-model="filter.username"
        >
        </v-text-field>
      </v-col>
      <!--   SearchName  -->
      <v-col xs="12" sm="6" md="3" lg="3">
        <v-text-field
          :clearable="true"
          dense
          v-bind:label="$t('email')"
          outlined
          prepend-inner-icon="search"
          v-model="filter.email"
        >
        </v-text-field>
      </v-col>

      <!--   SearchActive  -->
      <v-col xs="12" sm="6" md="3" lg="3">
        <v-select
          v-model="filter.status"
          :clearable="true"
          :items="statusItems"
          :item-text="getStatusText"
          item-value="value"
          v-bind:label="$t('userStatus')"
          v-bind:no-data-text="$t('noData')"
          persistent-hint
          dense
          outlined
          prepend-inner-icon="search"
        >
        </v-select>
      </v-col>
    </v-row>
    <v-row justify="end" no-gutters v-show="showSearch">
      <!--   Filter button   -->
        <v-btn 
          dark
          color="#2b5d66"
          large
          class="filter-button"
          @click="filterUsers()"
          >{{ $t('filter') }}</v-btn
        >
        <v-btn
          dark
          color="#2b5d66"
          large
          class="filter-button"
          @click="clearFilter()"
          >{{ $t('clearFilter') }}</v-btn
        >
    </v-row>

    <!--    users TABLE VIEW    -->
    <v-row>
      <v-col>
        <v-progress-linear indeterminate v-show="loading"></v-progress-linear>

        <v-data-table
          v-model="usersToView"
          :headers="headers"
          :items="allUsers"
          item-key="userId"
          class="elevation-1 grey lighten-3"
          v-bind:no-data-text="$t('noUsers')"
          v-bind:no-results-text="$t('noUsers')"
          :footer-props="{
            showFirstLastPage: true,
            'items-per-page-text': $t('rowsPerPage'),
          }"
          :items-per-page="itemsPerPage"
          @update:items-per-page="getItemPerPage"
          @update:options="updatePage($event)"
        >
          <!--    Table toolbar    -->
          <template v-slot:top>
            <!--<v-toolbar flat dark class="grey darken-3" color="#047083">-->
            <v-toolbar flat dark color="#2b5d66">
              <v-toolbar-title>{{ $t('users') }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <!-- New/Edit dialog -->
              <v-dialog
                v-model="dialog"
                max-width="1000px"
                persistent
              >             
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs"
                    v-on="on"
                    outlined>
                    <v-icon
                      left
                      dark
                    >
                    person_add_alt_1
                    </v-icon>
                    {{ $t('newUser') }}
                 </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="text-h5">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                    <v-form
                    ref="userForm"
                    lazy-validation>
                      <v-row>
                        <v-col
                          cols="12"
                          sm="6"
                          md="4"
                        >
                          <v-text-field
                            v-model="editedUser.name"
                            v-bind:label="$t('name') + '*'"
                            :rules="[v => !!v || '!']"
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                          md="4"
                        >
                          <v-text-field
                            v-model="editedUser.lastname"
                            v-bind:label="$t('lastname') + '*'"
                            :rules="[v => !!v || '!']"
                          ></v-text-field>
                        </v-col>
                        <v-col v-if="editedUser.userId <= 0"
                          cols="12"
                          sm="6"
                          md="4"
                        >
                          <v-text-field
                            v-model="editedUser.username"
                            v-bind:label="$t('username') + '*'"
                            :rules="[v => !!v || '!']"
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                          md="4"
                        >
                          <v-text-field
                            v-model="editedUser.email"
                            v-bind:label="$t('email') + '*'"
                            :rules="[v => !!v || '!', v => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || $t('emailValidation')]"
                          ></v-text-field>
                        </v-col>
                        <v-col v-if="editedUser.userId <= 0"
                          cols="12"
                          sm="6"
                          md="4"
                        >
                          <v-select 
                          v-model="editedUser.organizationId"
                          :items="organizations"
                          :rules="[v => !!v || '!']"
                          item-text="name"
                          item-value="organizationId"
                          v-bind:label="$t('organization') + '*'"
                          v-bind:no-data-text="$t('noData')"
                          >
                          </v-select>
                        </v-col>
                      </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="close"
                    >
                      {{ $t('cancel') }}
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="save"
                    >
                      {{ $t('save') }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
                
              </v-dialog>
            </v-toolbar>
          </template>

          <!-- Custom HEADER -->
          <template v-for="h in headers" v-slot:[`header.${h.value}`]="{ header }">
            {{ $t(header.text) }} 
          </template>

          <!--  Change of pagination. Put 'od' instead 'of'  -->
          <template v-slot:[`footer.page-text`]="items">
            {{ items.pageStart }} - {{ items.pageStop }} {{ $t('of') }}
            {{ items.itemsLength }}
          </template>

          <!-- menu options -->
          <template v-slot:item.menu="{ items, item}">
            <v-menu
            transition="slide-y-transition"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                    v-bind="attrs"
                    v-on="on"
                    class="mr-3"
                  >
                    arrow_drop_down
                  </v-icon>
              </template>

              <v-list>
                <v-list-item
                  v-for="i in menuItems"
                  v-bind:key="i.id"
                   @click="$router.push({ name: i.route, params: { user: item } })"
                   v-show="userPermission(item, i.permission)"
                >
                  <v-list-item-title>{{ $t(i.name) }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>

          <template v-slot:item.name="{ item }">
            {{ item.name + ' ' + item.lastname}}
          </template>

          <!-- Role -->
          <template v-slot:item.userOrganization="{ item }">
                <table style="font-size:11px;width:100%;">
                  <tbody>
                    <tr v-for="(organization, o) in item.userOrganization" :key="o">
                      <td width="45%" :style="organizationStyle(item.userOrganization)">{{ organization.name }}</td>
                      <td width="2.5%" :style="organizationStyle(item.userOrganization)"></td>
                      <td width="52.5%" :style="organizationStyle(item.userOrganization)"> 
                        <table>
                          <tr v-for="(role, r) in organization.role" :key="r" >
                           <td>- {{ getRoleDescription(role) }}</td>
                          </tr>
                        </table>
                      </td>                        
                    </tr>
                  </tbody>
                </table>
          </template>

          <!-- Active user -->
          <template v-slot:item.active="{ item }">
            <span> {{ activeUser(item.active) }} </span>
          </template>

          <!--  Actions  -->
          <template v-slot:[`item.actions`]="{ item }">
            <v-row>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-show="item.active"
                    v-bind="attrs"
                    v-on="on"
                    class="mr-3"
                    @click.stop.prevent="editUser(item)"
                  >
                    edit
                  </v-icon>
                </template>
                <span>{{ $t('edit') }}</span>
              </v-tooltip>

              <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
              <v-icon v-show="!item.active"
              v-bind="attrs"
              v-on="on" 
              class="mr-3"
              @click="activateUser(item)">
               done </v-icon>
              </template>
              <span>{{ $t('activate') }}</span>
              </v-tooltip>

              <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
              <v-icon v-show="item.active"
              v-bind="attrs"
              class="mr-3"
              v-on="on" 
              @click="resetPassword(item)"> restart_alt </v-icon>
              </template>
              <span>{{ $t('resetPassword') }}</span>
              </v-tooltip>

              <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
              <v-icon v-show="item.active"
              v-bind="attrs"
              class="mr-3"
              v-on="on" 
              @click="activateUser(item)"
              color="error"> cancel </v-icon>
              </template>
              <span>{{ $t('deactivate') }}</span>
              </v-tooltip>

            </v-row>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  name: "Users",
  components: {},
  data() {
    return {
        allUsers: [],
        showSearch: false,
        filtered: false,
        loading: false,
        itemsPerPage: 10,
        headers: [
            {
              text: "",
              sortable: false,
              value:"menu"
            },
            {
                text: "user",
                sortable: true,
                value: "name"
            },
            {
                text: "username",
                sortable: true,
                value: "username"
            },
            {
                text: "email",
                sortable: true,
                value: "email"
            },
            {
                text: "organizationRole",
                sortable: true,
                value: "userOrganization"
            },
            {
                text: "status",
                sortable: true,
                value: "active"
            },
            {
                text: "actions",
                sortable: false,
                value: "actions"
            }
          ],
          filter: {
            name: "",
            lastname: "",
            username: "",
            email: "",
            status: ""
          },
          statusItems: [
            {
              status: "Aktivan",
              statusEng: "Active",
              value: true
            },
            {
              status: "Deaktiviran",
              StatusEng: "Deactivated",
              value: false
            }
          ],
          editedIndex: -1,
          editedUser: {
            userId: -1,
            name: '',
            lastname: '',
            email: '',
            username: ''
          },
          defaultUser: {
            userId: -1,
            name: '',
            lastname: '',
            email: '', 
            username: ''
          },
          dialog: false,
          organizations: [],
          menuItems:[
            {
              id: 0,
              name: "userOrganization",
              route: "UserOrganization",
              permission: ""
            },
            {
              id: 1,
              name: "userRole",
              route: "UserRole",
              permission: ""
            },
            {
              id: 2,
              name: "userItemsCode",
              route: "UserItemCode",
              permission: "Fees"
            }
          ],
          usersToView: [],
          begin: 0,
          end: this.itemsPerPage
        }
  },
  created() {
    this.getOrganizations();

    if(localStorage.getItem('usersItemsPerPage'))
      this.itemsPerPage = JSON.parse(localStorage.getItem('usersItemsPerPage'));

    if(localStorage.getItem('usersFilter')) {
      this.filter = JSON.parse(localStorage.getItem('usersFilter'))
      this.filterUsers();
    } 
    else {
      this.getAllUsers();
    }
  },
  computed: {
    selectedOrganization() {
      return this.$store.getters.organizationId;
    },
    loggedUser() {
        return this.$store.getters.loggedUser;
    },
    searchLabel() {
      if(this.filtered)
        return this.$t('filtered');
      else  
        return this.$t('detailedSearch');
    },
    formTitle () {
      return this.editedIndex === -1 ? this.$t('newUser') : this.$t('editUser')
    }
  },
  methods: {
    getAllUsers() {
      console.log('all')
        this.loading = true;
        var searchUser = {
          name: null,
          lastname: null,
          username: null,
          email: null,
          status: null
        }
        var formData = new FormData();
        formData.append('searchUserJson', JSON.stringify(searchUser))

        this.axios.post('User/GetAllUsers?userId=' + this.loggedUser.userId, formData).then((response) => {
          this.allUsers = response.data;
          this.updateUserstoView();
          this.loading = false;
          console.log(this.allUsers)
        })
        .catch(err => console.log(err));
    },
    filterUsers() {
      console.log('filter')
      this.loading = true;
      var formData = new FormData();
      formData.append('searchUserJson', JSON.stringify(this.filter))
      
      this.axios.post('User/GetAllUsers?userId=' + this.loggedUser.userId, formData).then((response) => {
          this.allUsers = response.data;
          this.updateUserstoView();
          this.loading = false;  
          this.filtered = true;
        })
        .catch(err => console.log(err));

      localStorage.setItem('usersFilter', JSON.stringify(this.filter))
    },
    getItemPerPage(val) {
      localStorage.setItem('usersItemsPerPage', JSON.stringify(val))
    },
    /*editUser(user) {
        this.$router.push({ name: 'EditUser', query: {id: user.userId }})
    },*/
    validation() {
      return this.$refs.userForm.validate();
    },
    activateUser(user) {
        user.active = !user.active;
        this.axios.post('User/ActivateUser', user)
        .then(response => {
            if(response.status === 200) {
                this.$root.displayNotificationMsg(this.$t('activeUserMessage', {username: user.username, active: this.activeUser(user.active).toLowerCase()}), 'success');
                if(this.filtered) {
                  this.filterUsers();
                }
                else {
                  this.getAllUsers();
                }
            }
        })
        .catch(err => {
          console.log('err ' + err)
            this.$root.displayNotificationMsg(this.$t('noActiveUserMessage', {username: user.username, active: this.activeUser(!user.active).toLowerCase()}), 'error');
        });
    },
    activeUser(active) {
        if(active) {
          if(localStorage.getItem('language') === 'eng')
            return "Active";
          else
            return "Aktivan";
        }
          
        else {
          if(localStorage.getItem('language') === 'eng')
            return "Deactivated";
          else
            return "Deaktiviran";
        }
    },
    clearFilter() {
      this.filtered = false
      this.filter = {
        name: "",
        lastname: "", 
        username: "",
        email: "",
        status: ""
      }
        localStorage.removeItem('usersFilter')
        this.getAllUsers();
    },
    resetPassword(user) {
      this.axios.get('User/ResetPassword?userId=' + user.userId)
        .then(response => {
            if(response && response.status === 200) {
                this.$root.displayNotificationMsg('Resetovana je lozinka za korisnika ' + user.username, 'success');
            }
        })
        .catch(err => {
          console.log('err ' + err);
          this.$root.displayNotificationMsg('Nije resetovana lozinka za korisnika ' + user.username, 'success');
        });
    },
    organizationStyle(organization) {
      if(organization.length > 1)
        return "border-bottom: 1px solid lightgray;padding-bottom:5px;padding-top:5px;";
      else
        return "";
    },
    editUser (user) {
      this.editedIndex = this.allUsers.indexOf(user)
      this.editedUser = Object.assign({}, user)
      this.dialog = true
    },
    close() {
      this.dialog = false
      this.$nextTick(() => {
        this.editedUser = Object.assign({}, this.defaultUser)
        this.editedIndex = -1
      })
    },
    save() {
      if(this.validation()) {
          this.axios.post('User/Save', this.editedUser)
          .then(response => {
            if(response.status === 200 && response.data.message.length == 0 ) {
              if(this.filtered) {
                this.filterUsers();
              }
              else {
                this.getAllUsers();
                //this.allUsers = this.allUsers.slice(0, 0);
              }
              this.close();
              this.$root.displayNotificationMsg('Sačuvano', 'success')
            }
            else {
              this.$root.displayNotificationMsg(response.data.message, 'warning')
            }
          })
          .catch(err => console.log(err));
      }
      else {
          this.$root.displayNotificationMsg('Morate popuniti sva obavezna polja', 'warning')
      }
    },
    getOrganizations() {
      this.axios.get('Organization/GetAdminOrganization?userId=' + this.loggedUser.userId).then((response) => {
          this.organizations = response.data;
        })
        .catch(err => console.log(err));
    },
    userPermission(user, linkPermission) {
      if(linkPermission.length > 0) {
        const isFound = user.permission.some(element =>{
        if(element.permission === linkPermission)
          return true;
        });
        return isFound;
      }
      else {
        return true;
      }
    },
    getStatusText(item) {
      if(localStorage.getItem('language') === 'eng')
        return item.statusEng;
      else
        return item.status;
    },
    getRoleDescription(item) {
      if(localStorage.getItem('language') === 'eng')
        return item.descriptionEng;
      else
        return item.description;
    },
    updatePage(props) {
        this.begin = (props.page - 1) * this.itemsPerPage;
        this.end = this.itemsPerPage * props.page;
        this.updateUserstoView();
    },
    updateUserstoView() {
      this.usersToView = this.allUsers.slice(this.begin, this.end)
    }
  }
};
</script>

<style scoped>
.filter-button {
  max-height: 39px !important;
  margin-right: 15px;
}
.search-field {
  width: 1px;
}
</style>